import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";

// PRODUCTION FIREBASE
const firebaseConfig = {
  apiKey: "AIzaSyDQfpWDGrJsgXSjRzWRH73l4SxhiPj7f7E",
  authDomain: "benjitv-9d0ca.firebaseapp.com",
  projectId: "benjitv-9d0ca",
  storageBucket: "benjitv-9d0ca.appspot.com",
  messagingSenderId: "729480655103",
  appId: "1:729480655103:web:9c36a33581226fd8be9cca",
  measurementId: "G-RQPCBX1BHD",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
